import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CLPUser, UserResponse } from '../../../models/contact-modal/clpuser.model';
import { eFeatures, eUserRole } from '../../../models/contact-modal/enum.model';
import { RoleFeaturePermissions } from '../../../models/contact-modal/roleContainer.model';
import { SearchQueryResponse } from '../../../models/contact-modal/search.model';
import { ContactService } from '../../../services/contact-services/contact.service';
import { GlobalService } from '../../../services/contact-services/global.service';
import { ContactCommonSearchService } from '../../../services/contact-services/shared/contact-common-search.service';
import { LocalService } from '../../../services/contact-services/shared/local.service';
import { UtilityService } from '../../../services/contact-services/shared/utility.service';

@Component({
    selector: 'manage-duplicate',
    templateUrl: './manage-duplicate.component.html',
    styleUrls: ['./manage-duplicate.component.css']
})
export class ManageDuplicateComponent {
  showSpinner: boolean = false;
  private encryptedUser: string = '';
  user: CLPUser;
  roleFeaturePermissions: RoleFeaturePermissions;
  userResponse: UserResponse;
  queryDataLoaded: SearchQueryResponse;
  constructor(
    public _contactService: ContactService,
      private _utilityService: UtilityService,
      private _globalService: GlobalService,
    public _localService: LocalService,
    private _router: Router,
    public _contactCommonSearchService: ContactCommonSearchService,) {
    this._localService.isMenu = true;
  }

  ngOnInit() {
      this._globalService.getToken((token) => {
          if (token) {
              this.encryptedUser = token;
              this.authenticateR().then(() => {
                  if (this.user) {
                     
                  }
                  else
                      this._router.navigate(['/login']);
              });
          }
          else
              this._router.navigate(['/login']);
      });
  }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.ManageDuplicates)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("manage-duplicates.authenticateR", err.message, null, 'Features ' + eFeatures.None);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
  
}
